

































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/renderer/cmp-bool-cell-renderer.vue"
}
